import LibraryAccess from '../../../components/LibraryAccessForm/LibraryAccess';
type Props = {
  onCloseButtonClick: () => void;
};
const Library = ({ onCloseButtonClick }: Props) => {
  return <LibraryAccess onCloseButtonClick={onCloseButtonClick} />;
};

export default Library;
